import { createReduxConstants } from '@bibliocommons/utils-redux';

export default createReduxConstants('AVAILABILITY', {
  AVAILABILITY_DETAIL_REQUEST: null,
  AVAILABILITY_DETAIL_SUCCESS: null,
  AVAILABILITY_DETAIL_ERROR: null,

  DIGITAL_AVAILABILITY_REQUEST: null,
  DIGITAL_AVAILABILITY_SUCCESS: null,
  DIGITAL_AVAILABILITY_ERROR: null,

  HOLDINGS_PROBE_REQUEST: null,
  HOLDINGS_PROBE_SUCCESS: null,
  HOLDINGS_PROBE_ERROR: null
});



// WEBPACK FOOTER //
// ./app/constants/AvailabilityDetailConstants.js